<template>
	<div class="store-info-container">
		<!-- @TODO vi behöver ingen iframe, klienten kan sköta detta -->
		<div v-if="forceShowGMaps || showGMaps" class="store-gmaps-container" :style="{ marginBottom: shouldShowStreetView ? '0' : null }">
			<iframe v-if="shouldShowStreetView" class="store-gmaps-iframe" frameborder="0" :src="gMapsUrl" :style="{ height: computedMapHeight }"></iframe>
			<google-map v-else ref="map" @marker-clicked="clickStore" :initialPos="store.location" :markers="storeMarker" :height="computedMapHeight" :zoomLevel="15" />
			<icon-button
				v-if="! forceShowGMaps || shouldShowStreetView"
				variant="remove"
				size="tiny"
				cornerPlacement
				@click="hideGMaps"
			/>
		</div>
		<div v-if="useColLayout" class="d-flex justify-content-between">
			<div>
				<h3 v-if="hideExtraInfo && ! (forceShowGMaps || showGMaps)">
					Butiksinfo
				</h3>
				<div class="semibold text-secondary">
					{{ store.name }}
				</div>
				<div class="sub-title">
					{{ store.address }}, {{ store.city }}
				</div>
			</div>
			<div v-if="! (forceShowGMaps || showGMaps)">
				<img
					class="map-frame"
					:src="convertToCdnUrl('/img/storemaps/store_map.svg')"
					@click="toggleGMaps"
					alt="store map"
				>
			</div>
		</div>
		<div v-else>
			<img
				v-if="! (forceShowGMaps || showGMaps)"
				class="map-frame pull-right"
				:src="convertToCdnUrl('/img/storemaps/store_map.svg')"
				@click="toggleGMaps"
				alt="store map"
			>
			<h4 v-if="hideExtraInfo && ! (forceShowGMaps || showGMaps)" style="margin-top: 0">
				Butiksinfo
			</h4>
			<div class="semibold">
				{{ store.name }}
			</div>
			<div class="sub-title">
				{{ store.address }}, {{ store.city }}
			</div>
		</div>
		<div class="mt-4">
			<strong>{{ ts('OPEN_HOURS') }}</strong>
		</div>
		<div :class="{ 'row': useColLayout }" class="mt-3">
			<div :class="{ 'col-md-6': useColLayout }">
				<table v-if="store.regularOpenHours.length" class="table table-condensed" style="max-width: 385px">
					<thead>
						<tr>
							<th style="padding: 0" colspan="2"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(oh, index) in store.regularOpenHours" :key="'opening-hours-' + index">
							<td v-if="oh.toWeekday && oh.toWeekday < 6">{{ getWeekday(oh.fromWeekday) }} - {{ getWeekday(oh.toWeekday) }}</td>
							<td v-else>{{ getWeekday(oh.fromWeekday) }}</td>
							<td align="right">{{ oh.opening }} - {{ oh.closing }}</td>
						</tr>
					</tbody>
				</table>
				<table class="table table-condensed" v-if="store.abnormalOpenHours.length" style="max-width: 385px">
					<thead>
						<tr>
							<th colspan="2">{{ ts('ABNORMAL_OPEN_HOURS') }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(oh, index) in store.abnormalOpenHours" :key="'abnomarl-opening-hours-' + index">
							<template v-if="showAllOH && index > 3">
								<td>{{ oh.label ? oh.label + ' (' + oh.date + ')' : oh.date }}</td>
								<td align="right" v-if="oh.opening">{{ oh.opening }} - {{ oh.closing }}</td>
								<td align="right" v-else>Stängt</td>
							</template>
							<template v-else-if="index <= 3">
								<td>{{ oh.label ? oh.label + ' (' + oh.date + ')' : oh.date }}</td>
								<td align="right" v-if="oh.opening">{{ oh.opening }} - {{ oh.closing }}</td>
								<td align="right" v-else>Stängt</td>
							</template>
						</tr>
						<div v-if="showAllOH === false && store.abnormalOpenHours.length > 4" class="ml-2 mt-3 small">
							<a @click="toggleShowAllOH()">Visa fler avvikande öppettider</a>
						</div>
					</tbody>
				</table>
			</div>
			<div v-if="useColLayout && mq.current >= mq.md" class="col-md-6">
				<div v-if="store.infoTags.length">
					<div
						v-for="(tag, index) in store.infoTags"
						:key="'store-info-tags-' + index"
						style="border-top: 1px solid #dddddd; padding: 2px;"
					>
						<img :src="convertToCdnUrl(tag.icon)" class="mr-4" height="14px" alt="tag">
						<span class="small" :class="{'semibold': tag.label.indexOf('OBS') === 0}">{{ tag.label }}</span>
					</div>
				</div>
			</div>
		</div>
		<div v-if="hideExtraInfo && collapsed" @click="collapsed = false" class="ml-2 mt-3 small">
			<a>
				Visa mer <span class="glyphicon glyphicon-triangle-bottom" />
			</a>
		</div>
		<div v-if="! hideExtraInfo || ! collapsed">
			<div v-if="showImages" class="store-images">
				<label v-for="(image, index) in store.images"
					:key="'extra-info-img-' + index"
					class="pull-left m-2"
					@click="selectedImageIndex = index"
					style="cursor: pointer"
					:for="checkId"
				>
					<ximg
						:src="image.thumb"
						lazy
						:ariaLabel="store.name + ' store image thumbnail'"
						role="img"
					/>
				</label>
				<div class="pull-left m-2" style="cursor: pointer" v-if="store.streetViewUrl" @click="showStreetView">
					<ximg
						:src="convertToCdnUrl('/img/icons/streetview_thumb.png')"
						ariaLabel="streetview thumbnail"
						role="img"
					/>
				</div>
				<modal :checkId="checkId">
					<image-slideshow
						:images="store.images"
						:initialImageIndex="selectedImageIndex"
						noPreviews
					/>
				</modal>
				<div class="clearfix" />
			</div>
			<div v-if="! useColLayout || mq.current < mq.md">
				<div v-if="store.infoTags.length">
					<div v-for="(tag, index) in store.infoTags" :key="'info-tags-' + index" style="border-top: 1px solid #dddddd; padding: 2px;">
						<img :src="convertToCdnUrl(tag.icon)" class="mr-4" height="14px" alt="tag">
						<span class="small" :class="{'semibold': tag.label.indexOf('OBS') === 0}">{{ tag.label }}</span>
					</div>
				</div>
			</div>
			<div v-if="hideExtraInfo && ! collapsed" @click="collapsed = true" class="ml-2 mt-3 small">
				<a>
					Visa mindre <span class="glyphicon glyphicon-triangle-top" />
				</a>
			</div>
		</div>
	</div>
</template>

<script>
import bus from 'eventbus';
import mq from 'mediaQuery';
import { t } from 'datastore/i18n';
import { convertToCdnUrl } from 'utils';

import format from 'date-fns/format';
import startOfISOWeek from 'date-fns/start_of_iso_week';
import addDays from 'date-fns/add_days';

import svLocale from 'date-fns/locale/sv';

export default {
	props: {
		store: {
			type: Object,
			required: true,
		},
		/**
		 * True if both info rows and images should be hidden.
		 */
		hideExtraInfo: {
			type: Boolean,
			default: false,
		},
		/**
		 * Displays info rows and open hours on the same row when true.
		 */
		useColLayout: {
			type: Boolean,
			default: false,
		},
		/**
		 * True when images should be hidden.
		 */
		noImages: {
			type: Boolean,
			defualt: false,
		},
		/**
		 * Forces the map to always be expanded.
		 */
		forceShowGMaps: {
			type: Boolean,
			default: false,
		},
		titleColor:  {
			type: String,
			default: null,
		},
		addressColor: {
			type: String,
			default: null,
		},
		smallMap: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			mq,
			selectedImageIndex: 0,
			showGMaps: false,
			shouldShowStreetView: false,
			collapsed: true,
			showAllOH: false,
		};
	},
	mounted () {
		bus.$on('storeInfo.hideGMaps', this.hideGMaps);
	},
	beforeDestroy () {
		bus.$off('storeInfo.hideGMaps', this.hideGMaps);
	},
	methods: {
		convertToCdnUrl,
		toggleShowAllOH() {
			this.showAllOH = true;
		},
		clickStore (storeMarker) {
			this.$refs.map.panAndZoom(this.store.location, 15);
		},
		showStreetView () {
			if (this.showGMaps && this.shouldShowStreetView) {
				this.hideGMaps();
				return;
			}
			bus.$emit('storeInfo.hideGMaps');
			this.shouldShowStreetView = true;
			this.showGMaps = true;
		},
		toggleGMaps () {
			if (this.showGMaps) {
				this.hideGMaps();
				return;
			}
			bus.$emit('storeInfo.hideGMaps');
			this.showGMaps = true;
		},
		ts: t.prefix('STORE'),
		getWeekday (index) {
			const day = format(addDays(startOfISOWeek(new Date()), index - 1), 'dddd', {
				locale: svLocale,
			});
			return day[0].toUpperCase() + day.slice(1);
		},
	},
	computed: {
		computedMapHeight () {
			if (this.smallMap) {
				return '250px';
			}
			if (mq.current >= mq.md) {
				return '370px';
			}
			if (mq.current >= mq.sm) {
				return '310px';
			}
			return '250px';
		},
		storeMarker () {
			return [{
				id: 'store',
				icon: '/img/icons/wh_pin.svg', // Is converted to cdn url automagically.
				clickable: true,
				location: this.store.location,
				title: this.store.name,
			}];
		},
		gMapsUrl () {
			if (this.shouldShowStreetView) {
				return this.store.streetViewUrl;
			}
			return '//classic.webhallen.com/googlemaps.php?butikid=' + this.store.id;
		},
		hideGMaps () {
			return () => {
				this.showGMaps = false;
				this.shouldShowStreetView = false;
			};
		},
		showImages () {
			return ! this.noImages;
		},
		checkId () {
			return this._uid + '';
		},
	},
	watch: {
		$route (to, from) {
			if (from && to && to.params.id !== from.params.id && this.$refs.map) {
				// Reset the zoom level if the map gets reused.
				this.$refs.map.setZoomLevel(15);
			}
		},
	},
};
</script>
